<template>
    <div class="badge badge--warning card__badge">{{ count }}</div>
</template>

<script>
export default {
    name: 'Count',

    props: {
        count: {
            required: true,
            type: Number
        }
    }
}
</script>
